import { $error } from '@settings/errorContext';
import { Logger, LoggerFactory } from '@settings/services/logger/Logger';
import axios from 'axios';

import {
  DealPageServiceInterface,
  LoadDataError,
  UploadDealDocumentParams,
  UploadDealDocumentResponse,
} from './interface';
import { DealDocumentsResponse } from './types/documentsData';

/**
 * Сервис для работы со страницей сделки
 */
export class DealPageService implements DealPageServiceInterface {
  private readonly logger: Logger;

  private readonly bitrixEndpoint: string;

  private readonly token: string;

  /**
   * Конструктор сервиса
   *
   * @param logger
   * @param bitrixEndpoint
   * @param token
   */
  constructor(logger: LoggerFactory, bitrixEndpoint: string, token?: string) {
    this.logger = logger.make(`DealPageService`);
    this.bitrixEndpoint = bitrixEndpoint;
    this.token = `${token}`;
  }

  /**
   * Загрузка данных табы документов страницы сделки
   * @param dealId
   */
  async LoadDealDocumentsData(dealId: string): Promise<DealDocumentsResponse | LoadDataError> {
    try {
      const result = await axios.post<DealDocumentsResponse | LoadDataError>(
        this.bitrixEndpoint + '/api/request/documents/get',
        { deal_id: dealId, jwt: this.token },
        {
          headers: {
            'Content-Type': false,
          },
        }
      );

      this.logger.Debug(`Load deal page documents data`, result.data);
      return result.data;
    } catch (e) {
      this.logger.Error(`Error:`, e);
      $error.next(e);
    }
  }

  /**
   * Загрузка документа
   * @param dealId
   * @param id
   */
  async UploadDealDocument(
    dealId: string,
    payload: UploadDealDocumentParams
  ): Promise<UploadDealDocumentResponse> {
    const data = new FormData();
    data.append(payload.fieldCode, payload.file);
    data.append('deal_id', dealId);
    data.append('jwt', this.token);

    try {
      const result = await axios.post<UploadDealDocumentResponse>(
        this.bitrixEndpoint + '/api/request/documents/add',
        data
      );

      this.logger.Debug(`Uploaded document file`, result.data);
      return result.data;
    } catch (e) {
      this.logger.Error(`Error:`, e);
      $error.next(e);
    }
  }
}
